class DesktopCategoryMenu extends HTMLElement {
  #details;
  #summary;

  connectedCallback() {
    this.#details = this.querySelector('details');
    this.#summary = this.#details?.querySelector('summary');

    this.addEventListener('keydown', this.#handleKeydown);
    this.addEventListener('mouseenter', this.#handleMouseEnter);
    this.addEventListener('mouseleave', this.#handleMouseLeave);
    this.addEventListener('focusin', this.#handleFocusIn);
    this.addEventListener('focusout', this.#handleFocusOut);
    this.#summary?.addEventListener('click', this.#handleSummaryClick);
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.#handleKeydown);
    this.removeEventListener('mouseenter', this.#handleMouseEnter);
    this.removeEventListener('mouseleave', this.#handleMouseLeave);
    this.removeEventListener('focusin', this.#handleFocusIn);
    this.removeEventListener('focusout', this.#handleFocusOut);
    this.#summary?.removeEventListener('click', this.#handleSummaryClick);
  }

  #open = () => {
    if (this.#details instanceof HTMLDetailsElement) this.#details.open = true;
  };

  #close = () => {
    if (this.#details instanceof HTMLDetailsElement) this.#details.open = false;
  };

  #handleMouseEnter = () => {
    this.#open();
  };

  #handleMouseLeave = () => {
    this.#close();
  };

  #handleFocusIn = () => {
    this.#open();
  };

  #handleFocusOut = (event) => {
    if (event.relatedTarget instanceof Node && this.contains(event.relatedTarget)) return;
    this.#close();
  };

  #handleSummaryClick = (event) => {
    const usesHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!usesHover || event.detail === 0) return;

    event.preventDefault();
    this.#open();
  };

  #handleKeydown = (event) => {
    if (event.key !== 'Escape') return;

    const details = this.#details;
    if (!(details instanceof HTMLDetailsElement)) return;

    if (this.#summary instanceof HTMLElement) this.#summary.focus();
    this.#close();
  };
}

if (!customElements.get('desktop-category-menu')) {
  customElements.define('desktop-category-menu', DesktopCategoryMenu);
}
